module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('body', {
    staticClass: "hold-transition login-page"
  }, [_c('div', {
    staticClass: "login-box",
    staticStyle: {
      "margin": "11% auto"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box login-bbox"
  }, [_c('div', {
    staticClass: "box-body login-card-body pd-20"
  }, [_c('p', {
    staticClass: "login-box-msg login-txt"
  }, [_vm._v("Enter a new password")]), _vm._v(" "), _c('md-field', {
    class: _vm.getValidationClass('new_password')
  }, [_c('label', [_vm._v("New password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password",
      "name": "new_password",
      "id": "new_password"
    },
    model: {
      value: (_vm.form.new_password),
      callback: function($$v) {
        _vm.$set(_vm.form, "new_password", $$v)
      },
      expression: "form.new_password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pw-info md-error",
    style: (_vm.$v.form.new_password.required && this.backendValidationform.new_password.isError ? 'color:red;' : 'color: gray;')
  }, [_vm._v("Password must contain at least:\n                  6 Characters, 1 Uppercase letter, 1 Lowercase letter, 1 Special Character and 1 number")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-field', {
    class: _vm.getValidationClass('confirm_password')
  }, [_c('label', [_vm._v("Confirm password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password",
      "name": "confirm_password",
      "id": "confirm_password"
    },
    model: {
      value: (_vm.form.confirm_password),
      callback: function($$v) {
        _vm.$set(_vm.form, "confirm_password", $$v)
      },
      expression: "form.confirm_password"
    }
  }), _vm._v(" "), (!_vm.$v.form.confirm_password.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The confirm password is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.form.confirm_password.required && this.backendValidationForm.confirm_password.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.backendValidationForm.confirm_password.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
    staticClass: "rgbtnn md-raised md-accent login-btn btn-block",
    on: {
      "click": _vm.validateSubmission
    }
  }, [_vm._v("Reset")])], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo"
  }, [_c('img', {
    staticClass: "logo-login-signup",
    attrs: {
      "src": "/static/img/crp-images/Logo_RCP_Smart_App.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ba8406c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/user/UserPassResetView.vue
// module id = 2078
// module chunks = 1